// extracted by css-extract-rspack-plugin
export default {"line-loader":"line-loader-c2DVYL","lineLoader":"line-loader-c2DVYL","scroll":"scroll-R_9UwH","line-space":"line-space-pJmuVY","lineSpace":"line-space-pJmuVY"};